import * as Template from './template'
// @ts-ignore
import TemplateCommon from '@guitor/template-common'

Template.register(TemplateCommon as any)
